// Imported first by main.tsx so it runs before any other module reads
// auth_token: a shared family device's member session never survives a
// reload; only the device credential persists.
import { wipeSharedSessionOnBoot } from './sharedDevice'

wipeSharedSessionOnBoot()
